/**
 * 员工
 */
import { FC, useRef } from 'react';
import { SelectProps } from 'antd/es/select';
import { DefaultFormItemProps } from '@/common/components/Form/ts-config';
import { SearchOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import Employee from '../Select/Employee';
interface EmployeeConfig extends SelectProps {
  immediateOnce: boolean;
  debounceTimeout?: number;
}
export interface FormEmployeeProps {
  form?: any;
  placeholder?: string;
  allowClear?: boolean;
  extraParams?: any;
  config?: EmployeeConfig;
  changeHandle?: Function; // 映射select的onChange
  defaultOptions?: any[]; // 默认插入的已选列表
}
const FormEmployee: FC<FormEmployeeProps & DefaultFormItemProps> = ({
  name,
  label,
  rules,
  form,
  placeholder = `输入${label}关键词，并选择`,
  allowClear = true,
  extraParams = {},
  formItemConfig = {},
  config = { suffixIcon: <SearchOutlined className='fs-14'/> },
  changeHandle,
  defaultOptions,
}) => {
  const ref: any = useRef();
  const onChange = (val: any, option: any) => {
    form?.setFieldsValue({
      [name as string]: val,
    });
    if (changeHandle) {
      const data = ref.current.getData();
      const originOption = data.find(item => {
        return item.id === val;
      });
      changeHandle(val, option, originOption);
    }
  };

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      {...formItemConfig}
    >
      <Employee
        {...config}
        onRef={ref}
        extraParams={extraParams}
        allowClear={allowClear}
        placeholder={placeholder}
        onChange={onChange}
        defaultOptions={defaultOptions}
      />
    </Form.Item>
  );
};

export default FormEmployee;
